import React from "react";
import { formatAppDate } from "../../helpers/date-formatter";
import { Link } from "react-router-dom";
import { TrashIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import DataTable from "../table/DataTable";
import { TextStack } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";

function InvoiceMilestoneTable({ offset, data, path, onDelete }) {
  const columns = [
    {
      key: "sn",
      label: "SN",
      width: "90px",
      render: (_, key) => (offset && !offset.isNaN ? offset + key + 1 : key + 1),
    },
    {
      key: "description",
      label: "Description",
      render: (item) => <TextStack primary={item.description} />,
    },
    {
      key: "targetAmount",
      label: "Amount (€)",
      align: "center",
      width: "150px",
    },
    {
      key: "value",
      label: "Value (€)",
      align: "center",
      width: "140px",
    },
    {
      key: "status",
      label: "Status",
      width: "140px",
      render: (item) => <StatusBadge active={item.active} />,
    },
    {
      key: "createdOn",
      label: "Created On",
      width: "150px",
      render: (item) => formatAppDate(item.createdOn),
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "120px",
      render: (item) => (
        <ActionGroup>
          <ActionButton as={Link} to={`/${path}/${item.id}/edit`} color="blue" title="Edit">
            <PencilSquareIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton color="red" onClick={() => onDelete(item)} title="Delete">
            <TrashIcon className="h-5 w-5" />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={data}
      rowKey="id"
      minWidth="900px"
      emptyMessage="No milestones found."
    />
  );
}

export default InvoiceMilestoneTable;
